export const chevronLeftPath = "<path d=\"M10 4 L6 8 L10 12\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
